import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { BehaviorSubject, interval, Observable, Subject, Subscription, timer } from 'rxjs';
import { finalize, take, takeUntil } from 'rxjs/operators';
import { slideInAnimation } from 'src/app/core/models/animations';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { CommonDialogComponent } from 'src/app/features/group-sharing/common-dialog/common-dialog.component';
import { GroupSharingService } from 'src/app/features/group-sharing/group-sharing.service.component';

@Component({
  selector: 'app-theater',
  templateUrl: './theater.component.html',
  styleUrls: ['./theater.component.css'],
  animations: [
    slideInAnimation
  ]
})
export class TheaterComponent implements OnInit {

  @Input() eventId: string;
  isLoading = false;
  page = 'theaterPage';
  event: any = {};
  notifyType: string;
  message1: string;
  message2: string;
  featureGuests: any[];
  timeDiff: number;
  timeDiffValue: string;
  timeDiffToQnAEnd: number;
  isOpeningRemarksWatchStarted: boolean;
  isQnAWatchStarted: boolean;
  eventName: string;
  showNotification: boolean;
  openingRemarksSchedule: any;
  theaterSchedule: any;
  qnaSchedule: any;
  endOfFestivitiesSchedule: any;
  schedule: any;
  openingRemarksVimeoStream: SafeResourceUrl;
  openingRemarksVimeoStreamLink: SafeResourceUrl;
  qnaVimeoStream: SafeResourceUrl;
  qnaVimeoStreamLink: SafeResourceUrl;
  canUserAccessMovie: boolean;
  streamLink: SafeResourceUrl;
  message: string;
  everySecond: Observable<number> = timer(0, 1000);
  qnaEnded: boolean;
  QnAStartedMsg: true;
  notifications_none = 'notifications_none';
  av_timer = 'av_timer';
  theaterMsg1 = 'Please wait.';
  theaterMsg2 = 'The program will begin momentarily.';
  qnamsg1 = 'The Q&A session has started!';
  qnamsg2 = 'Click to watch now.';
  msg1 = 'Click here if you wish to go back to movie screening page!';
  msg2 = 'The movie has started!';
  subject = new BehaviorSubject(false);
  endEventSubject = new Subject();
  endEventNotify = new Subject();
  eventSob = new BehaviorSubject('PLEASE_WAIT');
  redCarpetSchedule: any;
  remainingOpeningRemarksStartTime: number;
  remainingQnaStartTime: number;
  remainingQnaEndTime: number;
  remainingFestiveEndTime: number;
  remainingTheaterStartTime: number;
  topeningRemarkWatchStarted: boolean;
  tevent: string;
  openingRemarkTimer: string;
  tqnaWatchStarted: boolean;
  qnaTimer: string;
  EndAllFestiveTime: number;
  showOpeningRemarksVideo: boolean;
  showQnasVideo: boolean;
  showOpeningRemarksGuests: boolean;
  showQnasGuests: boolean;
  showTheatersVideo: boolean;
  hideOrNotification: boolean;
  hideTheaterNotification: boolean;
  hideTheaterAgainNotification: boolean;
  hideQnaNotification: boolean;
  remainingRedCarpetStartTime: number;
  userId: any;
  isSlowMotionGraphicsLoading = false;
  durationMotiongraphics: any;
  premierData: any;
  motionGraphics: any;
  first_video: any;
  second_video: any;
  isGroupSharingActive: boolean = false;
  groupSharingEvent: any;
  activateLobby: boolean = false;
  motionGraphicVideo: any
  hideGroupSharing: boolean = false;
  theaterAgain: boolean = false;
  groupSharingActive: boolean = false;
  private processedMessages = new Set();
  private socketSubscription: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
    private spotlightService: SpotlightService,
    public domSanitizer: DomSanitizer,
    public groupSharingService: GroupSharingService,
    private _snackBar: MatSnackBar, private toast: HotToastService,) {
    this.eventId = route.snapshot.params.id;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.getEventDetails();
    this.socketSubscription = this.groupSharingService.socketObservable.subscribe((res) => {
      console.log(res)
      if (res && res != undefined && Object.keys(res).length != 0) {
        this.openSnackBarForParticipantAdded(res)
      }
    })
    this.groupSharingService.groupSharingActive.subscribe((res) => {
      this.groupSharingActive = res;
    })
  }

  getId(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (isNaN(id) || id === 0) {
      this.router.navigate(['/cinejoy/premiere/upcoming'], { relativeTo: this.route });
    } else {
      this.eventId = id.toString();
    }
  }

  displayFirstBanner(): void {
    this.message = '';

    interval(3000).pipe(take(1)).subscribe(() => {
      this.getId();
      this.setNotification(this.theaterMsg1, this.theaterMsg2, this.av_timer);
      this.showWelcomeMsg(this.isLoading, this.durationMotiongraphics);
    });
  }

  durationVideoTime(graphicsT: boolean): void {
    this.durationMotiongraphics = graphicsT;
    this.isLoading = true;
    if (graphicsT === true) {
      this.isSlowMotionGraphicsLoading = false;
      setTimeout(() => {
        this.isLoading = false;
      }, 4000);
    }
    this.displayFirstBanner();
  }

  showWelcomeMsg(loader?: any, flag?: any): void {
    if (loader === true || flag === 1) {
      this.isSlowMotionGraphicsLoading = false;
      this.isLoading = false;
    }
    interval(3000)
      .pipe(take(1))
      .subscribe(() => {
        this.showNotification = false;
        this.subject.next(true);
        this.subject.complete();
      });
  }
  setNotification(message1, message2, notifyType): void {
    this.notifyType = notifyType;
    this.message1 = message1;
    this.message2 = message2;
    this.showNotification = true;
  }

  notificationClick(): void {
    console.log('clicked');
    switch (this.tevent) {
      case 'QNA-WATCH': {
        this.showOpeningRemarksGuests = false;
        this.showOpeningRemarksVideo = false;
        this.showTheatersVideo = false;
        this.hideQnaNotification = true;
        this.showQnaGuest();
        this.showNotification = false;
        break;
      }
      case 'THEATER-WATCH': {
        this.showOpeningRemarksGuests = false;
        this.showOpeningRemarksVideo = false;
        this.hideTheaterNotification = true;
        this.showTheaterVideo();
        this.showNotification = false;
        break;
      }
      case 'THEATER-AGAIN-WATCH': {
        this.showOpeningRemarksGuests = false;
        this.showOpeningRemarksVideo = false;
        this.hideTheaterNotification = true;
        this.hideTheaterAgainNotification = true;
        this.showTheaterVideo();
        this.theaterAgain = true
        this.showNotification = false;
        break;
      }
      default: {
        break;
      }
    }
  }
  showOpeningRemarkGuests(): void {
    this.eventSob.next('SHOW_OR_GUESTS');
    this.showOpeningRemarksGuests = true;
  }
  showOpeningRemarkVideo(): void {
    this.eventSob.next('SHOW_OR_VIDEO');
    this.showOpeningRemarksGuests = false;
    this.showOpeningRemarksVideo = true;
  }
  showQnaGuest(): void {
    this.eventSob.next('SHOW_QNA_GUESTS');
    this.showQnasGuests = true;
  }
  showQnaVideo(): void {
    this.eventSob.next('SHOW_QNA_VIDEO');
    this.showQnasGuests = false;
    this.showQnasVideo = true;
  }
  showTheaterVideo(): void {
    this.eventSob.next('SHOW_THEATER_VIDEO');
    this.showTheatersVideo = true;
    this.showOpeningRemarksGuests = false;
    this.showQnasGuests = false;
    this.showQnasVideo = false;
  }
  getEventDetails(): void {
    // this.eventId = '140062';
    this.spotlightService.cmsGetPremierdeatails(this.eventId).subscribe((response2) => {
        this.premierData = response2;
        this.motionGraphics = this.premierData.motionGraphic;
        this.first_video = this.motionGraphics[0]?.firstVideo;
        this.second_video = this.motionGraphics[0]?.secondVideo;
        this.motionGraphicVideo = localStorage.getItem("motionGraphics" + this.eventId);
        if (this.motionGraphicVideo === 'done') {
      console.log("in if condition:" +this.motionGraphicVideo)
          this.isSlowMotionGraphicsLoading = false;
          this.isLoading = true;
          setInterval(() => {
            this.isLoading = false
          }, 4000)
          this.displayFirstBanner();
        } else  {
      console.log("in else condition:" +this.motionGraphicVideo)
          this.isSlowMotionGraphicsLoading = true;
          this.isLoading = true;
          setInterval(() => {
            this.isLoading = false
          }, 4000)
        }
        this.initEventData(response2);
        this.subject.subscribe(response => {
          if (response) {
            this.scheduleEvents();
            this.getStreamingLink();
          }
        });
      }, () => {
      });
  }
  initEventData(response: any): void {
    this.event = response;
    this.userId = response.user;
    this.setFeatureGuest(this.event.cinejoyFeaturedGuests);
    this.setPremierDetails(this.event.cinejoySpotlightsSchedule);
  }
  setPremierDetails(schedule: any): void {
    if (schedule && schedule.length) {
      this.openingRemarksSchedule = schedule.find(s => s.scheduleMainText === 'Opening Remarks');
      this.theaterSchedule = schedule.find(s => s.scheduleMainText === 'Screening of');
      this.qnaSchedule = schedule.find(s => s.scheduleMainText === 'Q&A with Cast & Creators');
      this.endOfFestivitiesSchedule = schedule.find(s => s.scheduleMainText === 'End of Festivities');
      this.redCarpetSchedule = schedule.find(s => s.scheduleMainText === 'Red Carpet');
      this.groupSharingEvent = schedule.find(s => s.scheduleMainText === 'GS2');
      console.log(this.groupSharingEvent)
    }
  }
  notificationShow: boolean = false;
  scheduleEvents(): void {
    if (this.openingRemarksSchedule) {
      const twentyFiveMinutes = 60 * 1000 * 25;
      if (this.redCarpetSchedule) {
        this.remainingRedCarpetStartTime = (this.redCarpetSchedule.scheduleTimeText - Date.now()) / 1000;
      }
      this.remainingOpeningRemarksStartTime = (this.openingRemarksSchedule.scheduleTimeText - Date.now()) / 1000;
      this.remainingTheaterStartTime = (this.theaterSchedule.scheduleTimeText - Date.now()) / 1000;
      if (this.qnaSchedule) {
        this.remainingQnaStartTime = (this.qnaSchedule.scheduleTimeText - Date.now()) / 1000;
        this.remainingQnaEndTime = ((this.qnaSchedule.scheduleTimeText + twentyFiveMinutes) - Date.now()) / 1000;
      }
      this.remainingFestiveEndTime = (this.endOfFestivitiesSchedule.scheduleTimeText - Date.now()) / 1000;
      this.EndAllFestiveTime = ((this.endOfFestivitiesSchedule.scheduleTimeText + (60 * 60 * 1000 * 10)) - Date.now()) / 1000;
      this.hideOrNotification = true;

      if (this.EndAllFestiveTime > 0) {
        if (this.remainingQnaEndTime < 1 || this.remainingFestiveEndTime < 1) {
          this.hideTheaterNotification = true;
          this.hideTheaterAgainNotification = true;
          this.showTheaterVideo();
          this.showNotification = false;
          this.showOpeningRemarksGuests = false;
          this.hideTheaterAgainNotification = true;
        }
      }

      timer(1, 1000)
        .pipe(
          takeUntil(this.endEventSubject),
          finalize(() => {
            this.tevent = 'THEATER-AGAIN-WATCH';
          }))
        .subscribe((seconds) => {
          // tslint:disable-next-line:prefer-const
          let currentTime = Date.now();
          if (this.redCarpetSchedule.scheduleTimeText < currentTime && this.openingRemarksSchedule.scheduleTimeText > currentTime) {
            this.endEventSubject.next();
            this.endEventSubject.complete();
            this.routeUserTo('/cinejoy/premiere/redcarpet/' + this.event.eventId + '/' + this.event.name.replaceAll(' ', '-'));
          }
          if (this.EndAllFestiveTime > seconds) {

            // Opening Remarks Enable Logic
            if (this.openingRemarksSchedule.scheduleTimeText <= currentTime && currentTime < this.theaterSchedule.scheduleTimeText) {
              if (this.hideOrNotification) {
                this.hideOrNotification = false;
                this.showOpeningRemarkGuests();
              }
              this.tevent = 'OPENING-REMARKS-WATCH';
            }

            // Theater Enable Logic
            if (this.theaterSchedule.scheduleTimeText <= currentTime && (this.qnaSchedule ? (this.qnaSchedule.scheduleTimeText > currentTime) : true)) {
              if (!this.hideTheaterNotification) {
                this.setNotification(this.msg2, this.qnamsg2, this.notifications_none);
              }
              this.tevent = 'THEATER-WATCH';
            }

            // Q&A Enable Logic
            if (this.qnaSchedule) {
              if (this.qnaSchedule.scheduleTimeText <= currentTime) {
                if (!this.hideQnaNotification) {
                  this.setNotification(this.qnamsg1, this.qnamsg2, this.notifications_none);
                }
                this.tevent = 'QNA-WATCH';
                this.showOpeningRemarksGuests = false;
              }
            }
            // Group sharing enable Q&A
            if (this.groupSharingEvent) {
              if (this.groupSharingEvent.scheduleTimeText <= currentTime && currentTime < this.endOfFestivitiesSchedule.scheduleTimeText) {
                this.groupSharingService.meetingEndObservable.next(true);
                this.activateLobby = true;
                this.hideQnaNotification = true;
                this.hideGroupSharing = true;
                if (this.theaterAgain == true) {
                  this.hideTheaterAgainNotification = true
                } else {
                  this.setNotification(this.msg1, '', this.notifications_none);
                }

                this.tevent = 'THEATER-AGAIN-WATCH';
                // this.router.navigate([`/cinejoy/group-sharing/lobby/${this.event.eventId}`])
              }
            }

            if (this.qnaSchedule) {
              if ((Date.now() - this.qnaSchedule.scheduleTimeText) > 600000 || Date.now() >= this.endOfFestivitiesSchedule.scheduleTimeText) {
                this.hideQnaNotification = true;
                this.showNotification = false;
              }
            } else {
              if (Date.now() >= this.endOfFestivitiesSchedule.scheduleTimeText) {
                this.hideQnaNotification = true;
                this.showNotification = false;
              }
            }


            // Theater again watch Enable Logic
            if (this.endOfFestivitiesSchedule.scheduleTimeText < currentTime && currentTime > this.groupSharingEvent.scheduleTimeText) {
              if (!this.hideTheaterAgainNotification && !this.showTheatersVideo) {
                this.setNotification(this.msg1, '', this.notifications_none);
              }
              this.tevent = 'THEATER-AGAIN-WATCH';
              this.hideGroupSharing = true;
              this.showOpeningRemarksGuests = false;

            }
          }
          if (seconds === 0) {
            this.notificationClick();
          }

          if (this.tevent === undefined) {
            this.endEventSubject.next();
            this.endEventSubject.complete();
            this.routeUserTo('/cinejoy/premiere/more-info/' + this.event.eventId + '/' + this.event.name.replaceAll(' ', '-'));
          }
          // console.log("Running Event: " + this.tevent + " time: " + seconds)
        });

      timer(1, 1000).pipe(takeUntil(this.endEventNotify), finalize(() => {

      })).subscribe((res) => {
        let currentTime = Date.now();
        const innerWidth = window.innerWidth;
        // if (this.groupSharingEvent && innerWidth  > 950) {
        //   if (this.groupSharingEvent.scheduleTimeText <= currentTime && currentTime < this.endOfFestivitiesSchedule.scheduleTimeText && !this.notificationShow) {
        //     this.notificationShow=true
        //     const toastRef = this.toast.show(`To continue your Group Sharing Experience, please click on 'Enter Group Sharing Lobby' button`, {
        //       autoClose: true,
        //       dismissible: true,
        //       theme: 'snackbar',
        //       position: 'top-right',
        //       duration: 100 * 100
        //     });
        //     this.endEventSubject.next();
        //     this.endEventNotify.complete()
        //   }else if(currentTime >= this.endOfFestivitiesSchedule.scheduleTimeText){
        //     this.notificationShow = false
        //   }
        // }
      })
      if (this.EndAllFestiveTime <= 0) {
        this.endEventSubject.next();
        this.endEventSubject.complete();
        this.hideGroupSharing=true
        this.routeUserTo('/cinejoy/premiere/more-info/' + this.event.eventId + '/' + this.event.name.replaceAll(' ', '-'));
      }

      this.schedule = this.openingRemarksSchedule;
      if (this.openingRemarksSchedule) {
        this.openingRemarksVimeoStreamLink = this.domSanitizer.bypassSecurityTrustResourceUrl('https://vimeo.com/event/' + this.openingRemarksSchedule.streamingLink.trim() + '/embed?quality=1080p&autoplay=1&muted=0');
      }
      if (this.qnaSchedule) {
        this.qnaVimeoStreamLink = this.domSanitizer.bypassSecurityTrustResourceUrl('https://vimeo.com/event/' + this.qnaSchedule.streamingLink.trim() + '/embed?quality=1080p&autoplay=1&muted=0');
      }
    }
  }
  routeUserTo(route: any): void {
    this.router.navigate([route], { relativeTo: this.route });
  }

  redirectUserBuyTicket(): void {
    location.href = ('/cinejoy/premiere/more-info/' + this.event.eventId + '/' + this.event.name.replaceAll(' ', '-'));
  }
  getStreamingLink(): void {
    this.spotlightService.getAgilitixStreamingLink(this.eventId,'SPOTLIGHT').subscribe((response) => {
      if (response.Error !== undefined) {
        // TODO: message pending
        //   this.streamLink = 'https://player.vimeo.com/video/516347937?quality=1080p';
        // this.canUserAccessMovie = true;
        this.canUserAccessMovie = false;
        this.message = response.Error;
      } else if (response.AccessStatus === 'AccessValid') {
        // this.streamLink = 'https://vimeo.com/showcase/' + response.StreamingID + '/embed';
        const url = 'https://vimeo.com/showcase/' + response.StreamingID + '/embed?autoplay=1&muted=0';
        this.streamLink = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
        this.canUserAccessMovie = true;
      } else if (response.AccessStatus === 'BeforeEvent') {
        this.canUserAccessMovie = false;
        this.message = 'Movie Viewing to occur 24-31 March 2025';
      } else if (response.AccessStatus === 'AccessExpired') {
        this.canUserAccessMovie = false;
        this.message = 'Your access to this movie is expired. Please purchase the movie again.';
      }
    }, (error: any) => {
      this.canUserAccessMovie = false;
      this.message = 'You do not have access to the movie.';
    });
  }
  setFeatureGuest(featureGuests: any[]): void {
    if (featureGuests && featureGuests.length) {
      featureGuests.sort((a, b) => a.guestSequence > b.guestSequence ? 1 : -1);
      this.featureGuests = featureGuests;
    }
  }
  secondsToDhms(seconds): string {
    seconds = Number(seconds);
    const d = Math.floor(seconds / (3600 * 24));
    const h = Math.floor((seconds % (3600 * 24)) / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return `${d}d:${h}h:${m}m:${s}s`;
  }

  isGroupShareActive(event) {
    console.log(event)
    this.isGroupSharingActive = event;
  }

  openSnackBarForParticipantAdded(message) {
    const toastRef = this.toast.show(CommonDialogComponent, {
      data: {
        fact: `You have been invited to ${message.description} by  ${message.hostFirstName}`,
        joinScreen: false
      },
      theme: 'snackbar',
      position: 'top-right',
      id:`notify-${message.roomId}-${message.userId}`,
      duration: 25000,
      persist:{ enabled: true, count: 1 }
        });
        setTimeout(() => this.processedMessages.delete(message.roomId+message.userId), 22000);

        setTimeout(() => {
            toastRef.close();
          }, 24000);

    toastRef.afterClosed.subscribe((e) => {
      console.log(e)
      if (e.dismissedByAction) {
        setTimeout(() => { 
          this.groupSharingService.joinFromInvite$.next({ 
            eventId: message.eventId, 
            customRoomId: message.customRoomId,
            roomId: message.roomId,   
            token: message.token 
          });
        }, 500);
      }
    });
  }

  redirectToLobby() {
    this.spotlightService.routeToQALobby.next(true)
    this.toast.close()
    this.router.navigate([`/cinejoy/group-sharing/qa-lobby/${this.event.eventId}`])
  }

  ngOnDestroy(): void {
    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }
    this.processedMessages.clear()
  }
}
